














































import { Component, Vue, Prop } from 'vue-property-decorator';
import AppModal from './ui/Modal.vue'
import contestService from '../../modules/contests/services/ContestService';
import LoadableButton from "@/shared/components/ui/LoadableButton.vue";

import { Getter } from 'vuex-class'
import { BALANCE, USERNAME } from "../../modules/auth/store/constants";

@Component({
    components: {
        AppModal,
        LoadableButton
    },
})
export default class PaymentModal extends Vue {
    @Getter(USERNAME) userName!: string;
    @Getter(BALANCE) balance!: string;

    @Prop() open!: boolean;
    @Prop() contestId!: any;
    @Prop() contestName!: string;
    @Prop() contestPrice!: string;

    private loading = false;

    private close() {
        this.$emit('close');
    }

    private async join() {
        this.loading = true;
        try {
            await contestService.joinContest(this.contestId, { username: this.userName, password: ''});
            this.$router.push(`/contests/${this.contestId}/lineup`)
        } catch (err) {

        }
        this.loading = false;
    }

    goTo(path: string) {
        this.$router.push(path)
    }

}
